<script lang="ts" setup>
import { useCommonStore } from '@stores/common'
import { useFeedbackStore } from '@stores/feedback'

import feedbackBgAvif from '@images/feedback/bg.avif'
import feedbackBgWebp from '@images/feedback/bg.webp'

import { AppImage } from '@UI/Images/AppImage'
import { AppLogoDomain } from '@UI/Logos/AppLogoDomain'
import { LoaderBlockDomain } from '@UI/Loaders/LoaderBlockDomain'

defineOptions({
  name: 'LayoutFeedback',
})

const commonStore = useCommonStore()
const feedbackStore = useFeedbackStore()
const ready = computed(() => !commonStore.isLoading && feedbackStore.isReady)
</script>

<template>
  <div class="cs-app-feedback">
    <AppImage
      class="cs-app-feedback__bg"
      :srcset="feedbackBgAvif"
      :src="feedbackBgWebp"
      alt="bg"
    />

    <div class="cs-app-feedback__logo">
      <AppLogoDomain color="inverse" />
    </div>

    <div :class="['cs-app-feedback__card', { done: feedbackStore.isDone }]">
      <template v-if="ready">
        <div class="cs-app-feedback__back">
          <slot name="back" />
        </div>

        <div class="cs-app-feedback__close">
          <slot name="close" />
        </div>
      </template>

      <div
        v-if="!feedbackStore.isDone"
        class="cs-app-feedback__header"
      >
        <slot name="header">
          <div class="cs-app-feedback__title cs-app-feedback__body-l btly-text-body-l">
            Lesson feedback
          </div>
        </slot>
      </div>

      <div :class="['cs-app-feedback__content', { done: feedbackStore.isDone }]">
        <slot
          v-if="ready"
        />
        <LoaderBlockDomain v-else />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="@scss/layouts/feedback.scss" />
